import React from 'react'
import { Button } from 'components'
import { withRouter } from 'react-router-dom'

class ThankYou extends React.Component<any> {

    public componentDidMount() {
        document.getElementsByTagName('html')[0].classList.add('page-product-detail')
    }

    public componentWillUnmount() {
        document.getElementsByTagName('html')[0].classList.remove('page-product-detail')
    }

    public handleClick = () => {
        this.props.history.push('/search')
    }

    public render() {
        return (
            <section className="page-layout">
                <main>
                    <h1 className="u-margin-top--md">Thank you<br/> for your <br/>order.</h1>
                </main>
                <footer>
                    <p>Your ordernumber is: {this.props.location.state.orderId} </p>
                    <p>For more details about the order, please login to your dashboard.</p>
                    <Button
                        full={true}
                        className="u-margin-top--md"
                        onClick={this.handleClick}
                    >
                        Make another order
                    </Button>
                </footer>
            </section>
        )
    }
}

export default withRouter(ThankYou)



// WEBPACK FOOTER //
// ./src/containers/ThankYou/index.tsx